export function calculatePasswordStrength(password: string): number {
    const length = password.length
    if (length === 0) {
        return 0
    }

    const nUpper = (password.match(/[A-Z]/g) || []).length
    const nLower = (password.match(/[a-z]/g) || []).length
    const nNum = (password.match(/[0-9]/g) || []).length
    const nSymbol = length - nUpper - nLower - nNum

    let score = 0

    score += length * 4

    if (nUpper !== length && nLower !== length) {
        if (nUpper !== 0) {
            score += (length - nUpper) * 2
        }
        if (nLower !== 0) {
            score += (length - nLower) * 2
        }
    }

    const allNumbers = nNum === length
    if (!allNumbers) {
        score += nNum * 4
    }

    score += nSymbol * 6

    for (let i = 1; i < length - 1; i++) {
        const char = password[i]
        if (/[0-9]/.test(char)) {
            score += 2
        } else if (/[^a-zA-Z0-9]/.test(char)) {
            score += 2
        }
    }

    if (nUpper + nLower === length) {
        score -= length
    }

    if (nNum === length) {
        score -= length
    }

    const counts: Record<string, number> = {}
    for (const char of password) {
        counts[char] = (counts[char] || 0) + 1
    }
    for (const char in counts) {
        const count = counts[char]
        if (count > 1) {
            const repeats = count - 1
            score -= Math.floor(repeats / (length - repeats)) + 1
        }
    }

    if (length > 1) {
        let runLength = 1
        for (let i = 1; i < length; i++) {
            const prevType = charType(password[i - 1])
            const currType = charType(password[i])
            if (prevType === currType) {
                runLength++
            } else {
                if (runLength >= 2) {
                    score -= (runLength - 1) * 2
                }
                runLength = 1
            }
        }
        if (runLength >= 2) {
            score -= (runLength - 1) * 2
        }
    }

    for (let i = 0; i < length - 2; i++) {
        const c1 = password.charCodeAt(i)
        const c2 = password.charCodeAt(i + 1)
        const c3 = password.charCodeAt(i + 2)

        if ((c2 === c1 + 1 && c3 === c1 + 2) ||
            (c2 === c1 - 1 && c3 === c1 - 2)) {
            let seqLength = 3
            const step = c2 > c1 ? 1 : -1
            let j = i + 3
            while (j < length && password.charCodeAt(j) === password.charCodeAt(j - 1) + step) {
                seqLength++
                j++
            }
            score -= (seqLength - 2) * 2
            i = j - 1
        }
    }

    return Math.max(0, score)
}

function charType(char: string): string {
    if (/[A-Z]/.test(char)) {
        return 'upper'
    }
    if (/[a-z]/.test(char)) {
        return 'lower'
    }
    if (/[0-9]/.test(char)) {
        return 'digit'
    }
    return 'symbol'
}
